/* eslint-disable id-length */
import { store } from "~/state/store";
import { node } from "~/util/dom";
import { ISubscriptionWithDescription } from "~/util/providers/share-position/interfaces";
import { watch, watchMapPosition } from "~/state/util";

export default function AccuracyMarker(subscription: ISubscriptionWithDescription) {
	SMap.WMMarker.call(this, null, undefined, {
		elm: node("div", { className: "ui-accuracy-marker" }),
		size: [0, 0],
		anchor: {
			left: 0,
			top: 0,
		},
	});

	const wtMap = watch(store.getState, "map", watchMapPosition);

	this.storeUnsubscribe = store.subscribe(wtMap(newPosition => {
		this._dom.container[SMap.LAYER_MARKER].style.setProperty("--accuracy", this._selected ? this.getAccuracy(this._subscription.position.accuracy, newPosition.zoom) : 0);
	}));


	this._selected = false;
	this.updateData(subscription);
}

function calculatePixelSize(latitude, zoomLevel) {
	const earthCircumference = 40075000; // in meters
	const tileSize = 256; // in pixels
	const latitudeRad = latitude * (Math.PI / 180); // convert latitude from degrees to radians
	const pixelSize = earthCircumference / tileSize * Math.cos(latitudeRad) / Math.pow(2, zoomLevel);

	return pixelSize;
}


// eslint-disable-next-line prefer-object-spread
AccuracyMarker.prototype = Object.create(Object.assign({}, SMap.Marker.prototype, SMap.WMMarker.prototype));

AccuracyMarker.prototype.$destructor = function $destructor() {
	SMap.WMMarker.prototype.$destructor.call(this);
	this.storeUnsubscribe?.();
};

AccuracyMarker.prototype.updateData = function updateData(subscription: ISubscriptionWithDescription) {
	const { zoom } = store.getState().map;

	this._subscription = subscription;
	this.setCoords(new SMap.Coords(subscription.position.lon, subscription.position.lat));
	this._dom.container[SMap.LAYER_MARKER].style.setProperty("--accuracy", this._selected ? this.getAccuracy(this._subscription.position.accuracy, zoom) : 0);
};

AccuracyMarker.prototype._build = function _build() {
	this._dom.container[SMap.LAYER_MARKER] = this._conf.elm;

	if (this._options.title) {
		this._dom.container[SMap.LAYER_MARKER].title = this._conf.title;
	}

	this._dom.active = this._dom.container[SMap.LAYER_MARKER];

	this._options.anchor = this._conf.anchor;
};

AccuracyMarker.prototype.setSelected = function setSelected(selected = false) {
	const { zoom } = store.getState().map;

	this._selected = selected;
	this._dom.container[SMap.LAYER_MARKER].style.setProperty("--accuracy", this._selected ? this.getAccuracy(this._subscription.position.accuracy, zoom) : 0);
};

AccuracyMarker.prototype.getAccuracy = function getAccuracy(accuracy: number, zoom: number) {
	const { lat } = this._subscription.position;

	return Math.floor(accuracy / calculatePixelSize(lat, zoom));
};
